/** Import pakej kes (Fasa 2 P2-4); sistem dipercayai dan rujukan luar ada dalam trust-ms.ts. */
export default {
  imports: {
    open: 'Import pakej',
    title: 'Import pakej kes',
    intro:
      'Pakej kes ialah fail bertandatangan yang dieksport oleh sistem lain. Ia disemak dahulu; tiada apa-apa ditulis sehingga anda mengimportnya.',
    file: 'Fail pakej (.pcp.zip)',
    upload: 'Muat naik dan semak',
    uploading: 'Memuat naik… {{percent}}%',
    checking: 'Menyemak pakej…',
    committing: 'Mengimport…',
    recent: 'Import terkini',
    resume: 'Papar',
    none: 'Belum ada import.',
    reportTitle: 'Laporan semakan',
    commit: 'Import ke ruang kerja ini',
    acknowledge: 'Tutup import ini',
    recheck: 'Semak semula',
    retry: 'Cuba lagi',
    findingsTruncated: 'Hanya {{count}} dapatan pertama ditunjukkan.',
    fields: {
      attributes: 'butiran serahan',
      profileRef: 'jenis pelan',
      declaredSrid: 'sistem koordinat',
      applicant_name: 'nama pemohon',
      applicant_firm: 'firma',
      applicant_email: 'alamat e-mel',
      applicant_professionalRegNo: 'nombor pendaftaran profesional',
      state: 'keadaan serahan',
    },
    committed: 'Pakej telah diimport.',
    closed: 'Tiada apa-apa diimport: ruang kerja ini sudah memegang apa yang dibawa oleh pakej.',
    openCase: 'Buka serahan',
    close: 'Tutup',
    stepOk: 'lulus',
    stepFailed: 'gagal',
    head: 'Sejarah sehingga peristiwa {{seq}}',
    counts: '{{events}} peristiwa, {{documents}} dokumen',
    sender: {
      verified: 'Ditandatangani oleh {{system}}.',
      unsigned: 'Pakej ini tidak ditandatangani.',
      unknown_kid: 'Ditandatangani dengan kunci yang tidak diterbitkan oleh mana-mana sistem dipercayai anda.',
      invalid: 'Tandatangan tidak sah.',
    },
    status: {
      uploading: 'Menunggu muat naik…',
      queued: 'Menunggu untuk bermula…',
      validating: 'Menyemak pakej…',
      validated: 'Telah disemak.',
      invalid: 'Pakej ini tidak boleh diimport.',
      committing: 'Mengimport…',
      committed: 'Telah diimport.',
      closed: 'Ditutup.',
      failed: 'Import terhenti.',
      expired: 'Pakej yang dimuat naik telah dipadam.',
    },
    steps: {
      unzip: 'Membuka pakej',
      bagit: 'Fail dan ringkasan',
      profile: 'Versi pakej',
      schemas: 'Kandungan',
      chain: 'Rantaian sejarah',
      boundary: 'Titik serahan',
      seal: 'Tandatangan',
      crs: 'Koordinat tapak',
      decide: 'Berbanding ruang kerja ini',
    },
    findings: {
      outcome_new: 'Serahan baharu: ia belum ada dalam ruang kerja ini.',
      outcome_fast_forward: 'Ia menyambung serahan yang dipegang di sini.',
      outcome_duplicate: 'Pakej ini telah diimport sebelum ini.',
      outcome_stale: 'Ruang kerja ini sudah memegang semua yang dibawa oleh pakej.',
      outcome_conflict: 'Pakej dan ruang kerja ini masing-masing telah bergerak, jadi ia tidak boleh diimport.',
      outcome_authority_violation: 'Sistem lain memegang serahan ini, jadi pengirim ini tidak boleh mengemas kininya.',
      package_too_large: 'Pakej lebih besar daripada 2 GB.',
      zip_unreadable: 'Fail ini bukan zip yang boleh dibaca.',
      unexpected_entry: 'Pakej memegang fail di luar susun atur pakej kes.',
      unsafe_entry_name: 'Pakej memegang nama fail yang tidak dibenarkan.',
      compression_ratio: 'Satu fail dalam pakej mengembang jauh melebihi saiz mampatnya.',
      digest_mismatch: 'Satu fail tidak sepadan dengan ringkasan yang disenaraikan oleh pakej.',
      profile_not_importable: 'Pakej awam tidak membawa data peribadi atau dokumen dan tidak boleh diimport.',
      procedure_not_runnable: 'Ruang kerja ini tidak menjalankan prosedur yang digunakan untuk membuat pakej.',
      procedure_not_runnable_pack_not_runnable:
        'Ruang kerja ini belum menjalankan prosedur pakej ini; import semula selepas ruang kerja ini dikemas kini untuk menjalankannya.',
      chain_broken: 'Rantaian sejarah tidak dapat disahkan.',
      boundary_not_reached: 'Pakej belum mencapai titik serahan yang dinamakannya.',
      seal_verified: 'Tandatangan disahkan.',
      seal_missing: 'Pakej ini tidak ditandatangani.',
      seal_unknown_kid: 'Kunci tandatangan bukan kunci yang diterbitkan oleh sistem dipercayai anda.',
      seal_invalid: 'Tandatangan tidak dapat disahkan.',
      seal_required: 'Sistem yang memegang serahan ini memerlukan pakej bertandatangan.',
      seal_required_tenant:
        'Ruang kerja ini menolak pakej yang tidak ditandatangani oleh salah satu sistem dipercayainya. Minta pentadbir menambah sistem penghantar di Tetapan → Perancangan → Sistem dipercayai, atau mematikan “Tolak pakej yang tidak ditandatangani oleh sistem dipercayai”, kemudian muat naik pakej itu semula.',
      package_id_reused: 'Pakej dengan id yang sama tetapi kandungan berbeza telah diimport sebelum ini.',
      local_case_deleted: 'Serahan ini telah dipadam di sini.',
      unknown_members_kept: 'Medan yang tidak dikenali oleh ruang kerja ini disimpan bersama serahan.',
      external_id_taken: 'Satu rujukan luar dalam pakej dipautkan di sini kepada serahan lain.',
      event_time_not_storable:
        'Masa sesuatu peristiwa ditulis dalam bentuk yang tidak boleh disimpan oleh ruang kerja ini.',
      chain_not_storable:
        'Sejarah memegang nilai yang perlu disembunyikan oleh ruang kerja ini, jadi ia tidak lagi boleh disahkan di sini.',
      transition_inconsistent:
        'Sejarah memindahkan serahan ke peringkat yang tidak dibenarkan oleh prosedurnya dari situ.',
      document_id_taken: 'Satu dokumen dalam pakej mempunyai id dokumen serahan lain di sini.',
      document_not_storable:
        'Pakej memegang dokumen asal yang tidak boleh disimpan oleh ruang kerja ini: hanya lukisan dan jenis dokumen yang diisytiharkan oleh versi pek serahan ini, masing-masing dengan id, boleh diimport.',
      attributes_not_storable: 'Butiran serahan dalam pakej tidak sesuai dengan borang ruang kerja ini ({{field}}).',
      key_not_storable: 'Pakej memegang nama medan yang tidak boleh disimpan oleh ruang kerja ini.',
      unknown_member_key_invalid: 'Pakej memegang medan tidak dikenali yang namanya tidak boleh disimpan.',
      event_path_invalid: 'Satu fail peristiwa tidak dinamakan mengikut cara pakej kes menamakannya.',
      unknown_event_type:
        'Peristiwa {{seq}} mempunyai jenis yang tidak dikenali oleh ruang kerja ini; ia disimpan seadanya.',
      case_urn_mismatch: 'Rujukan kes dalam case.json tidak menamakan kes yang diterangkannya.',
      document_mismatch: 'Satu lukisan disenaraikan dengan saiz yang berbeza daripada saiz failnya dalam pakej.',
      native_event_seq_invalid: 'Satu fail daripada sistem lain dikaitkan dengan peristiwa yang tiada dalam pakej.',
      too_many_entries: 'Pakej memegang lebih daripada 20,000 fail.',
      total_too_large: 'Pakej membuka kepada lebih daripada 4 GB.',
      entry_too_large: 'Satu fail dalam pakej lebih besar daripada 1 GB.',
      entry_unreadable: 'Satu fail dalam pakej tidak boleh dibaca.',
      small_file_too_large: 'Satu fail data pakej lebih besar daripada 16 MB.',
      small_total_too_large: 'Fail data pakej lebih besar daripada 256 MB bersama-sama.',
      duplicate_entry: 'Pakej memegang nama fail yang sama dua kali.',
      encrypted_entry: 'Satu fail dalam pakej disulitkan.',
      symlink_entry: 'Pakej memegang pautan ke fail lain.',
      unsupported_compression: 'Satu fail dalam pakej dimampatkan dengan cara yang tidak boleh dibaca.',
      bagit_txt_invalid: 'Pakej tiada bagit.txt yang sah.',
      manifest_missing: 'Pakej tiada senarai fail dan ringkasannya.',
      manifest_invalid: 'Senarai fail dan ringkasan tidak boleh dibaca.',
      manifest_path_invalid: 'Senarai fail menamakan fail di luar data pakej.',
      manifest_entry_missing: 'Satu fail yang disenaraikan oleh pakej tiada di dalamnya.',
      unlisted_payload: 'Pakej memegang fail yang tidak disenaraikannya.',
      tag_manifest_invalid: 'Senarai fail yang ditandatangani tidak boleh dibaca.',
      tag_manifest_coverage: 'Senarai fail yang ditandatangani tidak meliputi tepat fail yang sepatutnya.',
      tag_file_missing: 'Satu fail yang ditandatangani tiada dalam pakej.',
      tag_digest_mismatch: 'Satu fail yang ditandatangani tidak sepadan dengan ringkasannya.',
      bag_info_missing: 'Pakej tiada bag-info.txt.',
      bag_info_malformed: 'bag-info.txt tidak boleh dibaca.',
      bag_info_missing_label: 'bag-info.txt tiada {{label}}.',
      bag_info_duplicate: 'bag-info.txt menamakan {{label}} dua kali.',
      bag_info_invalid: 'bag-info.txt mempunyai nilai {{label}} yang tidak sah.',
      payload_oxum_mismatch: 'Bilangan dan saiz fail yang dinyatakan oleh bag-info.txt tidak sepadan dengan pakej.',
      profile_unsupported: 'Ruang kerja ini membaca pakej kes versi {{supported}} sahaja.',
      upcast_failed: 'Pakej tidak dapat dinaik taraf ke versi semasa.',
      case_json_missing: 'Pakej tiada case.json.',
      case_json_unreadable: 'case.json tidak boleh dibaca.',
      case_schema_unsupported: 'case.json bukan versi yang dinamakan oleh pakej.',
      case_json_invalid: 'case.json mempunyai medan yang tidak sah ({{field}}).',
      extensions_invalid: 'case.json memegang data daripada sistem lain dalam bentuk yang tidak boleh disimpan.',
      unknown_members_too_large:
        'Medan yang tidak dikenali oleh ruang kerja ini terlalu besar untuk disimpan bersama serahan.',
      privacy_path_invalid: 'case.json menyenaraikan peraturan privasi yang tidak boleh dibaca.',
      privacy_mismatch: 'Peraturan privasi dalam case.json tidak sepadan dengan ringkasannya.',
      bag_info_mismatch: 'bag-info.txt dan case.json tidak sepadan ({{label}}).',
      public_case_missing: 'Pakej tiada case.public.json.',
      public_case_invalid:
        'case.public.json tidak sah, memegang data peribadi, atau menerangkan kes lain atau titik lain dalam sejarahnya.',
      pack_mismatch: 'Ruang kerja ini menjalankan prosedur dengan peraturan privasi yang berbeza daripada pakej.',
      documents_unexpected: 'Pakej membawa senarai lukisan yang tidak pernah dibawa oleh jenis pakejnya.',
      documents_index_missing: 'Pakej tiada senarai lukisan walaupun sejarahnya menamakan lukisan.',
      documents_index_invalid: 'Senarai lukisan tidak boleh dibaca.',
      document_unlisted: 'Satu lukisan dalam senarai tiada antara fail pakej dengan ringkasannya.',
      document_type_unsupported:
        'Satu lukisan semakan {{revision}} adalah jenis yang tidak boleh disimpan oleh ruang kerja ini.',
      document_missing: 'Satu lukisan yang dinamakan oleh sejarah pada peristiwa {{seq}} tiada dalam pakej.',
      too_many_native_files: 'Pakej memegang lebih daripada 1,000 fail daripada sistem lain.',
      native_path_invalid: 'Satu fail daripada sistem lain tiada di tempat yang dinyatakan oleh case.json.',
      native_duplicate: 'case.json menyenaraikan satu fail daripada sistem lain dua kali.',
      native_mismatch:
        'Satu fail daripada sistem lain tidak sepadan dengan ringkasan atau saiz yang disenaraikan oleh case.json.',
      native_unlisted: 'Pakej memegang fail daripada sistem lain yang tidak disenaraikan oleh case.json.',
      letter_input_mismatch:
        'Satu fail surat keputusan dalam pakej bukan yang direkodkan oleh sejarahnya, atau tiada sejarah yang menamakannya.',
      letter_input_invalid: 'Satu surat keputusan dalam pakej tidak dapat disimpan di sini.',
      letter_id_taken: 'Satu surat keputusan dalam pakej mempunyai id surat serahan lain di sini.',
      letter_signed_invalid:
        'Satu surat keputusan bertandatangan dalam pakej tidak sepadan dengan surat yang dikatakan ditandatanganinya.',
      too_many_events: 'Pakej memegang lebih daripada 10,000 peristiwa.',
      event_unreadable: 'Satu fail peristiwa tidak boleh dibaca.',
      event_invalid: 'Satu fail peristiwa bukan peristiwa pakej kes yang sah.',
      event_not_canonical: 'Satu fail peristiwa tidak ditulis dalam bentuk tepat yang ditulis oleh pakej kes.',
      event_wrong_case: 'Satu fail peristiwa milik kes lain.',
      event_seq_mismatch: 'Satu fail peristiwa memegang peristiwa selain yang dinyatakan oleh namanya.',
      events_incomplete: 'Pakej memegang {{found}} daripada {{expected}} peristiwa dalam sejarahnya.',
      external_ids_mismatch: 'Rujukan luar dalam case.json bukan yang dipautkan oleh sejarahnya.',
      chain_unverifiable: 'Rantaian sejarah tidak dapat disemak.',
      head_mismatch: 'Sejarah berakhir pada peristiwa lain daripada yang dinyatakan oleh case.json.',
      replay_mismatch: 'Memainkan semula sejarah tidak menghasilkan serahan yang diterangkan oleh case.json.',
      based_on_off_chain: 'Titik yang dinyatakan oleh pakej sebagai asasnya tiada dalam sejarahnya.',
      verified_head_off_chain: 'Titik terakhir yang disahkan yang dinamakan oleh case.json tiada dalam sejarahnya.',
      transition_unknown: 'Peristiwa {{seq}} merekodkan langkah yang tidak boleh diambil oleh prosedur di sini.',
      event_type_mismatch: 'Peristiwa {{seq}} dilabel dengan jenis yang tiada pada langkahnya di sini.',
      clock_event_invalid:
        'Peristiwa {{seq}} merekodkan perubahan tarikh akhir yang tidak mungkin dibuat oleh prosedur di sini.',
      link_event_invalid:
        'Peristiwa {{seq}} merekodkan pautan kepada serahan induk yang tidak mungkin dibuat oleh prosedur di sini.',
      stage_unknown: 'Sejarah meninggalkan serahan pada peringkat yang tiada dalam prosedur di sini.',
      landing: 'Serahan mendarat pada peringkat {{stage}}.',
      seal_coverage: 'Tandatangan tidak meliputi tepat fail yang sepatutnya.',
      seal_head_mismatch: 'Tandatangan menamakan titik lain dalam sejarah daripada yang dipegang oleh pakej.',
      crs_unknown: 'Tapak berada dalam sistem koordinat yang tidak dikenali oleh ruang kerja ini.',
      crs_mismatch: 'Tapak berada dalam EPSG:{{srid}}, sedangkan serahan mengisytiharkan EPSG:{{declaredSrid}}.',
      crs_not_offered: 'Tapak berada dalam EPSG:{{srid}}, yang tidak ditawarkan oleh ruang kerja ini.',
      crs_out_of_range: 'Tapak mempunyai koordinat di luar sistem koordinatnya.',
      place_out_of_range: 'Tapak mempunyai kedudukan di luar julat longitud dan latitud.',
      place_inconsistent:
        'Tapak membawa salinan longitud dan latitud apabila tidak sepatutnya, atau tiada salinan apabila sepatutnya ada.',
      ring_not_closed: 'Sempadan tapak tidak tertutup.',
      geometry_too_large: 'Tapak mempunyai terlalu banyak titik ({{vertices}}; paling banyak 200,000).',
      geopackage_invalid: 'site.gpkg bukan GeoPackage.',
      extension_namespace_taken:
        'Pakej sudah memegang data di bawah {{namespace}}, nama yang akan digunakan untuk menyimpan medan yang tidak dikenalinya.',
      unknown: 'Dapatan: {{code}}',
    },
    errors: {
      IMPORT_FAILED: 'Sesuatu tidak kena semasa import. Cuba lagi.',
      IMPORT_PACKAGE_MISSING: 'Pakej yang dimuat naik tidak dapat dibaca. Muat naik semula.',
      IMPORT_PACKAGE_CHANGED: 'Pakej yang disimpan telah berubah selepas disemak. Muat naik semula.',
      IMPORT_OUTCOME_CHANGED:
        'Sesuatu telah berubah sejak pakej disemak (serahan, sistem dipercayai atau peraturan import). Muat naik semula untuk menyemaknya.',
      IMPORT_DOCUMENT_FAILED: 'Satu fail pakej tidak dapat disimpan. Cuba lagi.',
      IMPORT_EXTENSIONS_TOO_LARGE:
        'Kes ini akan menyimpan lebih banyak data daripada sistem lain daripada yang boleh dibawa oleh pakej kes (1 MiB), jadi ia tidak diimport.',
      IMPORT_STALE: 'Import terhenti tanpa diduga. Cuba lagi.',
    },
  },
  errors: {
    too_many_imports: 'Anda sudah mempunyai tiga pakej kes yang sedang disemak atau diimport. Tunggu satu selesai.',
    invalid_import: 'Butiran import itu tidak sah.',
    import_not_found: 'Import itu tidak ditemui.',
    import_not_uploaded: 'Pakej belum dimuat naik.',
    import_not_ready: 'Import itu tidak boleh berbuat demikian dalam keadaan semasanya.',
    import_outdated: 'Serahan ini telah berubah sejak pakej ini disemak. Semak semula.',
    import_closed: 'Import itu telah ditutup.',
    import_expired: 'Pakej yang dimuat naik telah dipadam. Muat naik semula.',
    stale_base: 'Pakej ini tidak menyambung serahan seperti yang ada di sini, jadi tiada apa-apa diimport.',
    package_id_reused: 'Pakej dengan id ini telah diimport dengan kandungan yang berbeza.',
    recipient_not_trusted: 'Sistem penerima mestilah salah satu sistem dipercayai anda (Tetapan → Perancangan).',
    external_id_taken: 'Rujukan luar itu sudah dipautkan kepada serahan lain.',
    invalid_external_id: 'Rujukan luar itu tidak sah.',
    external_id_issuer_unset: 'Tetapkan kod PBT majlis dalam Tetapan → Perancangan, atau nyatakan pengeluar id.',
    external_id_not_linked: 'Rujukan luar itu tidak dipautkan pada permohonan ini.',
    invalid_mirror_mark: 'Tanda senarai semak itu tidak sah.',
    mirror_item_unknown: 'Perkara senarai semak itu tiada lagi dalam himpunan. Sediakan himpunan semula.',
    mirror_not_available: 'Permohonan ini tiada himpunan OSC.',
    invalid_trusted_system: 'Sistem dipercayai itu tidak sah.',
    trusted_system_not_found: 'Sistem dipercayai itu tidak ditemui.',
    trusted_system_holds_cases:
      'Sistem ini masih memegang serahan yang dimajukan kepadanya. Tarik balik serahan itu dahulu.',
  },
  events: {
    case_external_id_linked: 'Rujukan luar dipautkan',
    case_external_id_unlinked: 'Pautan rujukan luar dibuang',
    case_foreign_event_recorded: 'Mesej daripada sistem lain direkodkan',
  },
} as const
